/* eslint-disable no-unused-vars */
//react context
import Amplify from 'aws-amplify';

import cogoToast from 'cogo-toast';
import React, { useEffect, useState } from 'react';
import { popularProducts } from '../data';
import { injected } from '../components/connectors';
import { useContracts } from '../hooks/useContracts';
import { useToast } from '@chakra-ui/react';
import CONTRACT_ADDRESS from './contractAddresses';

export const AppContext = React.createContext();
export const useCtx = () => {
  return React.useContext(AppContext);
};

export const CtxProvider = props => {
  const [cart, setCart] = useState([]);
  const [contract, setContract] = useState(undefined);
  const [isConnected, setIsConnected] = useState(false);
  const [products, setProd] = useState(popularProducts ? popularProducts : []);
  const [cartIds, setCartIds] = useState([]);
  const [auth, setAuth] = useState(null);
  const toast = useToast();

  Amplify.configure({
    Auth: {
      userPoolId: 'us-west-1_lqEXLKAq4', //UserPool ID
      region:
        'arn:aws:cognito-idp:us-west-1:474491464120:userpool/us-west-1_lqEXLKAq4',
      userPoolWebClientId: '5nf441i05sgma4hjeqdrpsfqc9', //WebClientId
    },
  });

  const serializeCartIds = () => {
    setCartIds(cart.map(item => item.id));
  };

  useEffect(() => {
    serializeCartIds();
    console.log(CONTRACT_ADDRESS.tron.marketPlace)
    if (localStorage.getItem('user')) {
      setIsConnected(true);
    }
    if (window.tronWeb) {
      window.tronWeb
        .contract()
        .at(CONTRACT_ADDRESS.tron.marketPlace)
        .then(res => setContract(res));
    }
  }, [cart]);

  const addCartItem = item => {
    let newItem = { ...item, count: 1 };
    setCart(prev => [...prev, newItem]);
    cogoToast.info('Item added to cart', { position: 'bottom-right' });
  };
  const removeCartItem = id => {
    setCart(prev =>
      prev.filter(item => {
        return item.id !== id;
      })
    );
    cogoToast.info('Item removed to cart', { position: 'bottom-right' });
  };

  const increment = id => {
    let oldCart = [...cart];
    let itemIndex = oldCart.findIndex(item => item.id === id);
    oldCart[itemIndex].count++;

    setCart(prev => [...oldCart]);
  };
  const decrement = id => {
    let oldCart = [...cart];
    let itemIndex = oldCart.findIndex(item => item.id === id);
    if (oldCart[itemIndex].count > 1) {
      oldCart[itemIndex].count--;
    }

    setCart(prev => [...oldCart]);
  };

  const addProductToList = prod => {
    setProd(prev => [prod, ...prev]);
  };
  const changeAuth = v => setAuth(v);

  const connect = async () => {
    try {
      if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
        const res = await window.tronLink.request({
          method: 'tron_requestAccounts',
        });
        let addr = window.tronWeb.defaultAddress.base58;
        if (res.code === 200) {
          window.localStorage.setItem('user', addr);
          setIsConnected(true);
          toast({
            status: 'success',
            title: 'Connected to wallet',
            description: `Address: ${addr}`,
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            status: 'error',
            title: 'Cannot connect to application',
            description: 'Please allow connection',
            duration: 5000,
            isClosable: true,
          });
        }
      } else {
        toast({
          status: 'error',
          title: 'Cannot detect wallet',
          description: 'Please install Tronlink',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (err) {
      console.log(err);
      toast({
        status: 'error',
        title: 'Cannot connect wallet',
        description: err,
        duration: 5000,
        isClosable: true,
      });
    }
  };

    const merchantSignUp = async (name) => {
      if (isConnected) {
        try {
          await contract.merchantSignUp(name).send({callValue: 5 * 1e6});
        } catch (err) {
          console.log(err);
        }
      } else {
        toast({
          status: 'error',
          title: 'Wallet not connected',
          description: `Please connect wallet`,
          duration: 3000,
          isClosable: true,
        })
      }
    }

  const disconnect = () => {
    const addr = localStorage.getItem('user');
    localStorage.removeItem('user');
    setIsConnected(false);
    toast({
      status: 'success',
      title: 'Wallet Disconnected',
      description: `Address: ${addr}`,
      duration: 3000,
      isClosable: true,
    });
  };

  const createAccount = async (name, email) => {
    try {
      await contract.createAccount(name, email).send();
    } catch (err) {
      console.log(err);
    }
  };

  const buyProduct = async (productId, price) => {
    try {
      console.log(contract);
      await contract.buyProduct(productId).send({ callValue: price * 1e6 });
    } catch (err) {
      console.log(err.message);
    }
  };

  const listProduct = async (url, price) => {
    try {
      await contract.listProduct(url, price).send();
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <AppContext.Provider
      value={{
        isConnected,
        connect,
        disconnect,
        merchantSignUp,
        listProduct,
        buyProduct,
        cart,
        addCartItem,
        removeCartItem,
        products,
        increment,
        decrement,
        cartIds,
        addProductToList,
        auth,
        changeAuth,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
